/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_SubInputs */

const th_home_sub = /** @type {(inputs: Home_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สิ่งที่คุณเกี่ยวข้อง และสิ่งที่กำลังจะมาถึง`)
};

const en_home_sub = /** @type {(inputs: Home_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What you are connected to, and what is next.`)
};

const ja_home_sub = /** @type {(inputs: Home_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`あなたに関わるもの、そして次に来るもの。`)
};

const zh_home_sub = /** @type {(inputs: Home_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`与你相关的一切，以及接下来会发生什么。`)
};

const es_home_sub = /** @type {(inputs: Home_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aquello con lo que estás conectado, y lo que viene ahora.`)
};

const pt_home_sub = /** @type {(inputs: Home_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aquilo a que você está ligado, e o que vem a seguir.`)
};

const id_home_sub = /** @type {(inputs: Home_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apa yang terhubung dengan Anda, dan apa yang berikutnya.`)
};

const fr_home_sub = /** @type {(inputs: Home_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce à quoi vous êtes lié, et ce qui vient ensuite.`)
};

const tl_home_sub = /** @type {(inputs: Home_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kung ano ang kaugnay mo, at kung ano ang susunod.`)
};

const vi_home_sub = /** @type {(inputs: Home_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Những gì gắn với bạn, và điều gì tiếp theo.`)
};

const ko_home_sub = /** @type {(inputs: Home_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`회원님과 연결된 것들, 그리고 다음에 있을 일.`)
};

const de_home_sub = /** @type {(inputs: Home_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Womit du verbunden bist, und was als Nächstes ansteht.`)
};

const ru_home_sub = /** @type {(inputs: Home_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`С чем вы связаны и что будет дальше.`)
};

const tr_home_sub = /** @type {(inputs: Home_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sizinle bağlantılı olanlar ve sırada ne var.`)
};

const it_home_sub = /** @type {(inputs: Home_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ciò a cui sei collegato e cosa viene dopo.`)
};

const pl_home_sub = /** @type {(inputs: Home_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Z czym jesteś związany i co dalej.`)
};

const uk_home_sub = /** @type {(inputs: Home_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`З чим ви пов'язані і що буде далі.`)
};

const hi_home_sub = /** @type {(inputs: Home_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आप किससे जुड़े हैं, और आगे क्या है।`)
};

const ar_home_sub = /** @type {(inputs: Home_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ما أنت مرتبط به، وما هو التالي.`)
};

const ms_home_sub = /** @type {(inputs: Home_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apa yang berkaitan dengan anda, dan apa yang seterusnya.`)
};

const bn_home_sub = /** @type {(inputs: Home_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আপনি কীসের সঙ্গে যুক্ত, আর এরপর কী।`)
};

const zh_tw2_home_sub = /** @type {(inputs: Home_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`與你相關的一切，以及接下來會發生什麼。`)
};

const zh_hk2_home_sub = /** @type {(inputs: Home_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`與你相關的一切，以及接下來會發生什麼。`)
};

const ur_home_sub = /** @type {(inputs: Home_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آپ کس سے جڑے ہیں، اور آگے کیا ہے۔`)
};

const fa_home_sub = /** @type {(inputs: Home_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آنچه با شما مرتبط است، و آنچه در پیش است.`)
};

const sw_home_sub = /** @type {(inputs: Home_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unachohusiana nacho, na kinachofuata.`)
};

const nl_home_sub = /** @type {(inputs: Home_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waar je mee te maken hebt, en wat er nu komt.`)
};

/**
* | output |
* | --- |
* | "What you are connected to, and what is next." |
*
* @param {Home_SubInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const home_sub = /** @type {((inputs?: Home_SubInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_SubInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_home_sub(inputs)
	if (locale === "ja") return ja_home_sub(inputs)
	if (locale === "zh") return zh_home_sub(inputs)
	if (locale === "es") return es_home_sub(inputs)
	if (locale === "pt") return pt_home_sub(inputs)
	if (locale === "id") return id_home_sub(inputs)
	if (locale === "fr") return fr_home_sub(inputs)
	if (locale === "tl") return tl_home_sub(inputs)
	if (locale === "vi") return vi_home_sub(inputs)
	if (locale === "ko") return ko_home_sub(inputs)
	if (locale === "de") return de_home_sub(inputs)
	if (locale === "ru") return ru_home_sub(inputs)
	if (locale === "tr") return tr_home_sub(inputs)
	if (locale === "it") return it_home_sub(inputs)
	if (locale === "pl") return pl_home_sub(inputs)
	if (locale === "uk") return uk_home_sub(inputs)
	if (locale === "hi") return hi_home_sub(inputs)
	if (locale === "ar") return ar_home_sub(inputs)
	if (locale === "ms") return ms_home_sub(inputs)
	if (locale === "bn") return bn_home_sub(inputs)
	if (locale === "zh-TW") return zh_tw2_home_sub(inputs)
	if (locale === "zh-HK") return zh_hk2_home_sub(inputs)
	if (locale === "ur") return ur_home_sub(inputs)
	if (locale === "fa") return fa_home_sub(inputs)
	if (locale === "sw") return sw_home_sub(inputs)
	if (locale === "nl") return nl_home_sub(inputs)
	return en_home_sub(inputs)
});